/**
 * Generated from RestStopCompletePopupLayout.fla
 */
export function RestStopCompletePopupLayout(this: IRestStopCompletePopupLayout) {
	const placeholderDuck = this.placeholderDuck;
	if (!placeholderDuck[0] && placeholderDuck.elementFactory) {
		placeholderDuck[0] = placeholderDuck.elementFactory(0,undefined);
	}
	if (placeholderDuck[0]) {
		RestStopCompletePopupLayout_templateDuck.call(placeholderDuck[0] as IRestStopCompletePopupLayout_templateDuck);
		placeholderDuck[0].x = 649.1;
		placeholderDuck[0].y = 327.9;
		placeholderDuck[0].width = 108.97;
		placeholderDuck[0].height = 68.43;
		if (placeholderDuck[0].onLayout) placeholderDuck[0].onLayout();
	}
	if (!placeholderDuck[1] && placeholderDuck.elementFactory) {
		placeholderDuck[1] = placeholderDuck.elementFactory(1,undefined);
	}
	if (placeholderDuck[1]) {
		RestStopCompletePopupLayout_templateDuck.call(placeholderDuck[1] as IRestStopCompletePopupLayout_templateDuck);
		placeholderDuck[1].x = 646.6;
		placeholderDuck[1].y = 432.35;
		placeholderDuck[1].width = 108.97;
		placeholderDuck[1].height = 68.43;
		if (placeholderDuck[1].onLayout) placeholderDuck[1].onLayout();
	}
	if (!placeholderDuck[2] && placeholderDuck.elementFactory) {
		placeholderDuck[2] = placeholderDuck.elementFactory(2,undefined);
	}
	if (placeholderDuck[2]) {
		RestStopCompletePopupLayout_templateDuck.call(placeholderDuck[2] as IRestStopCompletePopupLayout_templateDuck);
		placeholderDuck[2].x = 520.1;
		placeholderDuck[2].y = 317.85;
		placeholderDuck[2].width = 108.97;
		placeholderDuck[2].height = 68.43;
		if (placeholderDuck[2].onLayout) placeholderDuck[2].onLayout();
	}
	if (!placeholderDuck[3] && placeholderDuck.elementFactory) {
		placeholderDuck[3] = placeholderDuck.elementFactory(3,undefined);
	}
	if (placeholderDuck[3]) {
		RestStopCompletePopupLayout_templateDuck.call(placeholderDuck[3] as IRestStopCompletePopupLayout_templateDuck);
		placeholderDuck[3].x = 523.1;
		placeholderDuck[3].y = 435.85;
		placeholderDuck[3].width = 108.97;
		placeholderDuck[3].height = 68.43;
		if (placeholderDuck[3].onLayout) placeholderDuck[3].onLayout();
	}
	if (!placeholderDuck[4] && placeholderDuck.elementFactory) {
		placeholderDuck[4] = placeholderDuck.elementFactory(4,undefined);
	}
	if (placeholderDuck[4]) {
		RestStopCompletePopupLayout_templateDuck.call(placeholderDuck[4] as IRestStopCompletePopupLayout_templateDuck);
		placeholderDuck[4].x = 392.1;
		placeholderDuck[4].y = 312.45;
		placeholderDuck[4].width = 108.97;
		placeholderDuck[4].height = 68.43;
		if (placeholderDuck[4].onLayout) placeholderDuck[4].onLayout();
	}
	if (!placeholderDuck[5] && placeholderDuck.elementFactory) {
		placeholderDuck[5] = placeholderDuck.elementFactory(5,undefined);
	}
	if (placeholderDuck[5]) {
		RestStopCompletePopupLayout_templateDuck.call(placeholderDuck[5] as IRestStopCompletePopupLayout_templateDuck);
		placeholderDuck[5].x = 392.1;
		placeholderDuck[5].y = 447.25;
		placeholderDuck[5].width = 108.97;
		placeholderDuck[5].height = 68.43;
		if (placeholderDuck[5].onLayout) placeholderDuck[5].onLayout();
	}
	if (!placeholderDuck[6] && placeholderDuck.elementFactory) {
		placeholderDuck[6] = placeholderDuck.elementFactory(6,undefined);
	}
	if (placeholderDuck[6]) {
		RestStopCompletePopupLayout_templateDuck.call(placeholderDuck[6] as IRestStopCompletePopupLayout_templateDuck);
		placeholderDuck[6].x = 263.6;
		placeholderDuck[6].y = 295.75;
		placeholderDuck[6].width = 108.97;
		placeholderDuck[6].height = 68.43;
		if (placeholderDuck[6].onLayout) placeholderDuck[6].onLayout();
	}
	if (!placeholderDuck[7] && placeholderDuck.elementFactory) {
		placeholderDuck[7] = placeholderDuck.elementFactory(7,undefined);
	}
	if (placeholderDuck[7]) {
		RestStopCompletePopupLayout_templateDuck.call(placeholderDuck[7] as IRestStopCompletePopupLayout_templateDuck);
		placeholderDuck[7].x = 263.6;
		placeholderDuck[7].y = 462.25;
		placeholderDuck[7].width = 108.97;
		placeholderDuck[7].height = 68.43;
		if (placeholderDuck[7].onLayout) placeholderDuck[7].onLayout();
	}
	if (!placeholderDuck[8] && placeholderDuck.elementFactory) {
		placeholderDuck[8] = placeholderDuck.elementFactory(8,undefined);
	}
	if (placeholderDuck[8]) {
		RestStopCompletePopupLayout_templateDuck.call(placeholderDuck[8] as IRestStopCompletePopupLayout_templateDuck);
		placeholderDuck[8].x = 268.6;
		placeholderDuck[8].y = 467.25;
		placeholderDuck[8].width = 108.97;
		placeholderDuck[8].height = 68.43;
		if (placeholderDuck[8].onLayout) placeholderDuck[8].onLayout();
	}
	const energyBarSegment = this.energyBarSegment;
	if (!energyBarSegment[0] && energyBarSegment.elementFactory) {
		energyBarSegment[0] = energyBarSegment.elementFactory(0,undefined);
	}
	if (energyBarSegment[0]) {
		RestStopCompletePopupLayout_energyBarSegment0.call(energyBarSegment[0] as IRestStopCompletePopupLayout_energyBarSegment0);
		energyBarSegment[0].x = 747.4;
		energyBarSegment[0].y = 429.65;
		energyBarSegment[0].width = 14.50;
		energyBarSegment[0].height = 12.25;
		if (energyBarSegment[0].onLayout) energyBarSegment[0].onLayout();
	}
	if (!energyBarSegment[1] && energyBarSegment.elementFactory) {
		energyBarSegment[1] = energyBarSegment.elementFactory(1,undefined);
	}
	if (energyBarSegment[1]) {
		RestStopCompletePopupLayout_energyBarSegment1.call(energyBarSegment[1] as IRestStopCompletePopupLayout_energyBarSegment1);
		energyBarSegment[1].x = 762.85;
		energyBarSegment[1].y = 429.4;
		energyBarSegment[1].width = 14.50;
		energyBarSegment[1].height = 12.25;
		if (energyBarSegment[1].onLayout) energyBarSegment[1].onLayout();
	}
	if (!energyBarSegment[2] && energyBarSegment.elementFactory) {
		energyBarSegment[2] = energyBarSegment.elementFactory(2,undefined);
	}
	if (energyBarSegment[2]) {
		RestStopCompletePopupLayout_energyBarSegment1.call(energyBarSegment[2] as IRestStopCompletePopupLayout_energyBarSegment1);
		energyBarSegment[2].x = 778;
		energyBarSegment[2].y = 429.4;
		energyBarSegment[2].width = 14.50;
		energyBarSegment[2].height = 12.25;
		if (energyBarSegment[2].onLayout) energyBarSegment[2].onLayout();
	}
	if (!energyBarSegment[3] && energyBarSegment.elementFactory) {
		energyBarSegment[3] = energyBarSegment.elementFactory(3,undefined);
	}
	if (energyBarSegment[3]) {
		RestStopCompletePopupLayout_energyBarSegment3.call(energyBarSegment[3] as IRestStopCompletePopupLayout_energyBarSegment3);
		energyBarSegment[3].x = 793.2;
		energyBarSegment[3].y = 429.4;
		energyBarSegment[3].width = 14.50;
		energyBarSegment[3].height = 12.25;
		if (energyBarSegment[3].onLayout) energyBarSegment[3].onLayout();
	}
	if (!energyBarSegment[4] && energyBarSegment.elementFactory) {
		energyBarSegment[4] = energyBarSegment.elementFactory(4,undefined);
	}
	if (energyBarSegment[4]) {
		RestStopCompletePopupLayout_energyBarSegment4.call(energyBarSegment[4] as IRestStopCompletePopupLayout_energyBarSegment4);
		energyBarSegment[4].x = 808.2;
		energyBarSegment[4].y = 429.65;
		energyBarSegment[4].width = 14.50;
		energyBarSegment[4].height = 12.25;
		if (energyBarSegment[4].onLayout) energyBarSegment[4].onLayout();
	}
	const bg = this.bg;
	RestStopCompletePopupLayout_bg.call(this.bg);
	bg.x = 515;
	bg.y = 347.5;
	bg.width = 721.99;
	bg.height = 531.68;
	if (bg.onLayout) bg.onLayout();
	const continueButton = this.continueButton;
	RestStopCompletePopupLayout_continueButton.call(this.continueButton);
	continueButton.x = 512;
	continueButton.y = 573.1;
	continueButton.width = 188.00;
	continueButton.height = 114.50;
	if (continueButton.onLayout) continueButton.onLayout();
	const templateDuck = this.templateDuck;
	RestStopCompletePopupLayout_templateDuck.call(this.templateDuck);
	templateDuck.x = 771.1;
	templateDuck.y = 380.85;
	templateDuck.width = 108.97;
	templateDuck.height = 68.43;
	if (templateDuck.onLayout) templateDuck.onLayout();
	const duckNameBg = this.duckNameBg;
	RestStopCompletePopupLayout_duckNameBg.call(this.duckNameBg);
	duckNameBg.x = 737.35;
	duckNameBg.y = 386.65;
	duckNameBg.width = 34.00;
	duckNameBg.height = 18.00;
	if (duckNameBg.onLayout) duckNameBg.onLayout();
	const energyBarEmpty = this.energyBarEmpty;
	RestStopCompletePopupLayout_energyBarEmpty.call(this.energyBarEmpty);
	energyBarEmpty.x = 771.25;
	energyBarEmpty.y = 428.25;
	energyBarEmpty.width = 93.75;
	energyBarEmpty.height = 23.00;
	if (energyBarEmpty.onLayout) energyBarEmpty.onLayout();
	return this;
}
function RestStopCompletePopupLayout_bg(this: IRestStopCompletePopupLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-modal.png", 0.500, 0.500);
	return this;
}
function RestStopCompletePopupLayout_continueButton(this: IRestStopCompletePopupLayout_continueButton) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-btn-done.png", 0.503, 0.271);
	return this;
}
function RestStopCompletePopupLayout_templateDuck(this: IRestStopCompletePopupLayout_templateDuck) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-duckswap-female-duck.png", 0.501, 0.502);
	return this;
}
function RestStopCompletePopupLayout_duckNameBg(this: IRestStopCompletePopupLayout_duckNameBg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-duckswap-duckname-container.png", 0.500, 0.500);
	return this;
}
function RestStopCompletePopupLayout_energyBarEmpty(this: IRestStopCompletePopupLayout_energyBarEmpty) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-energy-bg.png", 0.501, 0.500);
	return this;
}
function RestStopCompletePopupLayout_energyBarSegment0(this: IRestStopCompletePopupLayout_energyBarSegment0) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-energy-red-left.png", 0.500, 0.510);
	return this;
}
function RestStopCompletePopupLayout_energyBarSegment1(this: IRestStopCompletePopupLayout_energyBarSegment1) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-energy-yellow-mid.png", 0.517, 0.490);
	return this;
}
function RestStopCompletePopupLayout_energyBarSegment3(this: IRestStopCompletePopupLayout_energyBarSegment3) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-energy-green-mid.png", 0.517, 0.490);
	return this;
}
function RestStopCompletePopupLayout_energyBarSegment4(this: IRestStopCompletePopupLayout_energyBarSegment4) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-flying-energy-green-right.png", 0.500, 0.510);
	return this;
}
interface IRestStopCompletePopupLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface IRestStopCompletePopupLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface IRestStopCompletePopupLayoutSprite extends IRestStopCompletePopupLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface IRestStopCompletePopupLayoutText extends IRestStopCompletePopupLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface IRestStopCompletePopupLayoutPolygon extends Array<number> {
}
interface IRestStopCompletePopupLayout {
	readonly placeholderDuck: IRestStopCompletePopupLayoutArray<IRestStopCompletePopupLayout_templateDuck>;
	readonly energyBarSegment: IRestStopCompletePopupLayoutArray<IRestStopCompletePopupLayout_energyBarSegment0|IRestStopCompletePopupLayout_energyBarSegment1|IRestStopCompletePopupLayout_energyBarSegment3|IRestStopCompletePopupLayout_energyBarSegment4>;
	readonly bg: IRestStopCompletePopupLayout_bg;
	readonly continueButton: IRestStopCompletePopupLayout_continueButton;
	readonly templateDuck: IRestStopCompletePopupLayout_templateDuck;
	readonly duckNameBg: IRestStopCompletePopupLayout_duckNameBg;
	readonly energyBarEmpty: IRestStopCompletePopupLayout_energyBarEmpty;
}
interface IRestStopCompletePopupLayout_bg extends IRestStopCompletePopupLayoutSprite {
}
interface IRestStopCompletePopupLayout_continueButton extends IRestStopCompletePopupLayoutSprite {
}
interface IRestStopCompletePopupLayout_templateDuck extends IRestStopCompletePopupLayoutSprite {
}
interface IRestStopCompletePopupLayout_duckNameBg extends IRestStopCompletePopupLayoutSprite {
}
interface IRestStopCompletePopupLayout_energyBarEmpty extends IRestStopCompletePopupLayoutSprite {
}
interface IRestStopCompletePopupLayout_energyBarSegment0 extends IRestStopCompletePopupLayoutSprite {
}
interface IRestStopCompletePopupLayout_energyBarSegment1 extends IRestStopCompletePopupLayoutSprite {
}
interface IRestStopCompletePopupLayout_energyBarSegment3 extends IRestStopCompletePopupLayoutSprite {
}
interface IRestStopCompletePopupLayout_energyBarSegment4 extends IRestStopCompletePopupLayoutSprite {
}
